import * as Cookies from "es-cookie"
import en from "assets/locales/en"
import ja from "assets/locales/ja"

export const getLocale = () => {
  let locale = Cookies.get("locale")
  if (typeof locale === "undefined") {
    // クロスブラウザに対応した言語設定取得
    locale =
      (window.navigator.languages && window.navigator.languages[0]) ||
      window.navigator.language ||
      window.navigator.userLanguage ||
      window.navigator.browserLanguage
    setLocale(locale)
  }
  if (locale.startsWith("ja-")) {
    locale = "ja"
  } else if (locale.startsWith("en-")) {
    locale = "en"
  }
  return locale
}

export const setLocale = locale => {
  Cookies.set("locale", locale)
}

export const toggleLocale = () => {
  if (getLocale() === "en") {
    setLocale("ja")
  } else {
    setLocale("en")
  }
}

export const getMessages = locale => {
  switch (locale) {
    case "en":
      return en
    case "ja":
      return ja
    default:
      return ja
  }
}

export const getLocaleJaOrEn = () => {
  let locale = getLocale()
  if (!(locale === "en" || locale === "ja")) {
    locale = "ja"
  }
  return locale
}
